import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  buys: [],
  tempBuys: [],
  isLoading: false,
  tempPurchaseReturn: [],
  purchaseReturns: [],
   warehouseProducts: [],  
  warehouseProductsLoading: false, 
  pagination: {
    total: 0,
    page: 1,
    pages: 1,
  },
  returnPagination: {
    total: 0,
    page: 1,
    pages: 1,
  },
};

const buySlice = createSlice({
  name: "buys",
  initialState,
  reducers: {
    setBuys(state, action) {
      state.buys = action.payload;
      state.isLoading = false;
    },
    setProducts(state, action) {
      state.products = action.payload;
      state.isLoading = false;
    },
        setBuyPagination(state, action) {
          state.pagination = action.payload;
        },
        setBuyReturnPagination(state, action) {
          state.returnPagination = action.payload;
        },
    setTempBuys(state, action) {
      state.tempBuys = action.payload;
    },
    setTempPurchaseReturn(state, action) {
      state.tempPurchaseReturn = action.payload;
    },
    setPurchaseReturns(state, action) {
      state.purchaseReturns = action.payload;
    },
  setWarehouseProducts(state, action) {
      state.warehouseProducts = action.payload;
      state.warehouseProductsLoading = false;
    },
    setWarehouseProductsLoading(state, action) {
      state.warehouseProductsLoading = action.payload;
    },

    addBuy(state, action) {
      state.buys.push(action.payload);
      state.tempBuys.push(action.payload);
    },
    updateBuy(state, action) {
      const { index, buy } = action.payload;
      state.buys?.splice(index, 1, buy);
      state.tempBuys?.splice(index, 1, buy);
    },
    deleteBuy(state, action) {
      const { index } = action.payload;
      state.buys.splice(index, 1);
      state.tempBuys.splice(index, 1);
    },
    setBuyIsLoading(state, action) {
      state.isLoading = true;
    },
  },
});

export const {
  setBuys,
  setTempBuys,
  setBuyPagination,
  setBuyReturnPagination,
  addBuy,
  updateBuy,
  deleteBuy,
  setBuyIsLoading,
  setPurchaseReturns,
  setTempPurchaseReturn,
  setProducts,
   setWarehouseProducts, 
  setWarehouseProductsLoading,  
} = buySlice.actions;
export default buySlice.reducer;
